import { LeftArrowIcon } from '@airship-platform/jam-web/icons';
import Button, { ButtonProps } from '@mui/material/Button';
import { PropsWithChildren } from 'react';
import { Link } from 'react-router';
import { useNavigationHistory } from '../../contexts/NavigationHistoryContext';

export type BackButtonProps = ButtonProps & {
  defaultPath: string;
  backPath?: string;
  displayIcon?: boolean;
  icon?: React.ReactNode;
};

const BackButton: React.FC<PropsWithChildren<BackButtonProps>> = ({
  defaultPath,
  backPath,
  displayIcon,
  icon,
  children,
  ...props
}) => {
  const { navigationHistory } = useNavigationHistory();
  return (
    <Button
      component={Link}
      startIcon={displayIcon && (icon ?? <LeftArrowIcon />)}
      to={backPath ?? navigationHistory.at(-2) ?? defaultPath}
      {...props}
    >
      {children || 'Back'}
    </Button>
  );
};

export default BackButton;
